import * as React from 'react';
import { ProtectedPageWrapper } from '../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { WorkplaceAssessmentListingView } from '../features/activities/WorkplaceAssessmentActivity/WorkplaceAssessmentListingView';

export default function WorkplaceAssessmentListingPage(): JSX.Element 
{

	return (
		<ProtectedPageWrapper requiredPermissions={['ViewActivity']} selectedMenuItemKey="workplaceassessment">
            <WorkplaceAssessmentListingView />
		</ProtectedPageWrapper>
	);
}
